import React, { Component } from 'react';
import { IDropDownValue } from '../../Models';
import { WidgetHelper } from '../WidgetHelper';
import { TreeSelect } from 'antd';

const { SHOW_ALL } = TreeSelect;

interface ISearchOffersKeywordsState {
    keywords: string | null;
    selectedDomains: string[];
    domains: any[];
    tmpKeywords: string | null;
}

interface ISearchOffersKeywordsProps {
    offerSearchUrl: string | null;
    getKeywordAndDomainFilter?: (
        keywords: string,
        launchSearch: boolean
    ) => void;
    selectedDomains?: string[];
    dropdownValueDomains: IDropDownValue[];
    keywords?: string | null;
    dictNbSelectedDomain: string;
    dictSearchBy: string;
    dictWorkFamilies: string;
    dictJobsSkillsKeywords: string;
    dictSelectedDomain: string;
    dictDomain: string;
    dictSearch: string;
    dictRemoveFilter: string;
    searchParamsTypeActiris: boolean;
    domainSelectId: string;
    keywordInputId: string;
    isCovid: boolean;
    setCurrentSearchedWord?: (keywords: string) => void;
}

export class SearchOffersKeywordsWidget extends Component<
    ISearchOffersKeywordsProps,
    ISearchOffersKeywordsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            domains: this.props.dropdownValueDomains || [],
            tmpKeywords: this.props.keywords || '',
            keywords: this.props.keywords || '',
            selectedDomains: this.props.selectedDomains || [],
        };
    }

    getDomainIds(): string {
        return this.state.selectedDomains
            ? this.state.selectedDomains.join(',')
            : '';
    }

    getKeywordAndDomainFilter = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const keywords = this.state.keywords ? this.state.keywords : '';

        if (this.props.offerSearchUrl) {
            window.location.href =
                this.props.offerSearchUrl +
                '?keywords=' +
                keywords +
                '&domains=' +
                this.getDomainIds() +
                '&session=0';
        }

        if (this.props.getKeywordAndDomainFilter) {
            window.history.replaceState(
                null,
                '',
                '?keywords=' + keywords + '&domains=' + this.getDomainIds()
            );

            this.props.getKeywordAndDomainFilter(keywords, true);
        }
        this.props.setCurrentSearchedWord?.(keywords);
    };

    handleKeyWordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const nextKeywords = event.target.value;

        this.setState({ keywords: nextKeywords });

        if (
            !this.props.offerSearchUrl &&
            this.props.getKeywordAndDomainFilter
        ) {
            this.props.getKeywordAndDomainFilter(nextKeywords, false);
        }
    };

    handleChange = (optionsList: any) => {
        this.setState({ selectedDomains: optionsList });
    };

    onSelectDomain = (selectedItem: string[]) => {
        this.setState({
            selectedDomains: selectedItem,
            tmpKeywords: this.state.keywords,
        });
    };

    handleBlurKeywordAndDomain = () => {
        if (
            !this.props.offerSearchUrl &&
            this.props.getKeywordAndDomainFilter
        ) {
            this.props.getKeywordAndDomainFilter(
                this.state.keywords ? this.state.keywords : '',
                true
            );
        }
    };

    componentDidUpdate(prevProps: ISearchOffersKeywordsProps) {
        if (
            this.props.dropdownValueDomains !== prevProps.dropdownValueDomains
        ) {
            this.setState({ domains: this.props.dropdownValueDomains });
        }
        if (this.props.selectedDomains !== prevProps.selectedDomains) {
            this.setState({
                selectedDomains: this.props.selectedDomains || [],
            });
        }
        if (this.props.keywords !== prevProps.keywords) {
            this.setState({ keywords: this.props.keywords ?? '' });
        }
    }
    render() {
        return (
            <>
                <form
                    className="job-search"
                    data-skip-captcha="true"
                    onSubmit={this.getKeywordAndDomainFilter}
                >
                    <div className="form-group">
                        <label
                            htmlFor={this.props.keywordInputId}
                            className="sr-only sr-only-focusable"
                        >
                            {this.props.dictSearchBy}{' '}
                            {this.props.dictJobsSkillsKeywords}
                        </label>
                        <div className="field-icon case">
                            <input
                                id={this.props.keywordInputId}
                                title={this.props.dictJobsSkillsKeywords}
                                type="text"
                                placeholder={this.props.dictJobsSkillsKeywords}
                                value={
                                    this.state.keywords
                                        ? this.state.keywords
                                        : ''
                                }
                                onChange={this.handleKeyWordChange}
                            />
                        </div>
                    </div>
                    {this.props.offerSearchUrl && (
                        <>
                            <div className="form-group">
                                <div className="field-icon objectif">
                                    <label
                                        htmlFor={this.props.domainSelectId}
                                        className="sr-only"
                                    >
                                        {this.props.dictWorkFamilies}
                                    </label>

                                    <TreeSelect
                                        id={this.props.domainSelectId}
                                        treeData={this.state.domains}
                                        value={this.state.selectedDomains}
                                        onChange={this.onSelectDomain}
                                        treeCheckable
                                        showSearch={false}
                                        showCheckedStrategy={SHOW_ALL}
                                        styles={{
                                            popup: {
                                                root: {
                                                    width: 305,
                                                    maxHeight: 300,
                                                    overflow: 'auto',
                                                },
                                            },
                                        }}
                                        placeholder={
                                            this.props.dictWorkFamilies
                                        }
                                        maxTagCount={25}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                            <div className="form-group submit">
                                <button
                                    type="submit"
                                    className="theme-reactive"
                                >
                                    <i className="icon-search"></i>
                                    {this.props.dictSearch}
                                </button>
                            </div>
                        </>
                    )}
                </form>
            </>
        );
    }
}

WidgetHelper.register(
    SearchOffersKeywordsWidget,
    'search-offers-keywords-widget'
);
